// Module
var code = "<div class=\"post-input-box\" ng-paste=\"$ctrl.onPaste({$event})\"> <ty-simplemde toolbar-preset=\"post\" on-change=\"$ctrl.onChange({$value})\" value=\"$ctrl.value\" submit-on-enter=\"false\" placeholder=\"What's on your mind?\"></ty-simplemde> </div> ";
// Exports
export default code;